import gql from 'graphql-tag'
export default gql`mutation deleteSieveSizeMutation($sieveSizeId: Int!) {
  deleteSieveSize(sieveSizeId: $sieveSizeId) {
    success
  }
}`